<template>
  <div class="form-section">
    <div class="h2">{{ title }}</div>
    <hr>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ["title"]
};
</script>
